import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { Button, Toast, NavBar, Tab, Tabs, Swipe, SwipeItem, PullRefresh, AddressEdit, Popup, Field, Cell, CellGroup, Icon, Empty, Dialog, Form, List, RadioGroup, Radio, DatetimePicker, Image, Loading, DropdownMenu, DropdownItem,Search, Switch, Uploader,Cascader,Picker,Divider, Progress, CheckboxGroup, Checkbox } from 'vant'

Vue.use(Button)
Vue.use(Toast)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(NavBar)
Vue.use(Swipe)
Vue.use(SwipeItem)
Vue.use(PullRefresh)
Vue.use(AddressEdit)
Vue.use(Popup)
Vue.use(Field)
Vue.use(Cell)
Vue.use(CellGroup)
Vue.use(Icon)
Vue.use(Empty)
Vue.use(Dialog)
Vue.use(Form)
Vue.use(List)
Vue.use(RadioGroup)
Vue.use(Radio)
Vue.use(DatetimePicker)
Vue.use(Image)
Vue.use(Loading)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Search)
Vue.use(Switch)
Vue.use(Uploader)
Vue.use(Cascader)
Vue.use(Picker)
Vue.use(Divider)
Vue.use(Progress)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)

Vue.config.productionTip = false
Vue.prototype.$merchant = {}
Vue.prototype.$needRefresh = false

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
